@if ((hideHeader$ | async) === false) {
  <header class="flex flex-row content-stretch items-stretch justify-between">
    <mat-icon [svgIcon]="SparrowIcon.SparrowLogo" class="sparrow-logo self-center" />
    <div class="flex flex-auto"></div>
    <button
      (menuClosed)="mobileIsOpen = false"
      (menuOpened)="mobileIsOpen = true"
      [matMenuTriggerFor]="menu"
      [ngClass]="{ open: mobileIsOpen }"
      class="menu-btn-icon"
    >
      <span></span><span></span><span></span><span></span>
    </button>
  </header>
}

<mat-menu #menu="matMenu" backdropClass="header-mobile-backdrop">
  <div class="flex flex-col content-stretch items-stretch justify-stretch gap-8">
    <div class="flex flex-auto flex-col content-stretch items-stretch justify-stretch gap-4">
      @for (link of siteLinks; track link.url) {
        @if (link.isVisible) {
          <a
            #rla1="routerLinkActive"
            [ngClass]="rla1.isActive ? 'active' : ''"
            [routerLinkActiveOptions]="{ exact: true }"
            [routerLink]="link.url"
            class="nav-anchor flex flex-row content-center items-start justify-start"
            routerLinkActive="active-route"
          >
            <div class="flex flex-row content-center items-center justify-start gap-2">
              <mat-icon [svgIcon]="link.icon" class="size-9!" />
              <span class="placeholder-white">{{ link.label }}</span>
            </div>
          </a>
        }
      }
    </div>
    <div class="flex flex-auto flex-col content-stretch items-stretch justify-stretch gap-4">
      <div class="flex flex-row content-center items-center justify-start">
        <div class="lang-abbr flex w-16 justify-center">{{ selectedLanAbbr | uppercase }}</div>
        <div (click)="onLangToggle($event)" class="dropdown flex w-32">
          <div class="flex flex-row content-center items-center justify-start"
            ><span class="drop-btn">{{ selectedLanLabel }}</span
            ><mat-icon
              [ngClass]="{ 'rotate-180': langDropdown }"
              [svgIcon]="SparrowIcon.CaretDown"
              class="ml-1 size-4!"
          /></div>
          @if (langDropdown) {
            <div class="dropdown-content flex flex-col content-stretch items-stretch justify-stretch">
              @for (loc of localizationLinks; track loc.lang) {
                <button (click)="changeLanguage(loc.lang)">
                  {{ loc.label }}
                </button>
              }
            </div>
          }
        </div>
      </div>
      <button (click)="logout()" class="nav-btn flex flex-row content-center items-center justify-start">
        <b class="flex w-16 justify-center"><mat-icon [svgIcon]="SparrowIcon.SignOut" /></b>
        <span>Logout</span>
      </button>
    </div>
  </div>
</mat-menu>
